<template>
  <div id="user-create" class="row">
    <form id="create-user-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <label v-if="administrator">
        {{ 'Registrar'|t }}
        <AutoCompleteRegistrar v-model="registrar" :email="true" required="true"></AutoCompleteRegistrar>
      </label>

      <label>
        {{ 'Login name'|t }}
        <input type="text" v-model="username" required="required" minlength="3" maxlength="64" />
      </label>

      <label>
        {{ 'Password'|t }}
        <input type="text" v-model="password" required="required" minlength="5" maxlength="64" />
      </label>

      <label v-if="administrator">
        <input type="checkbox" v-model="admin" /> {{ 'Admin role'|t }}
      </label>

      <label>
        <input type="checkbox" v-model="gui_login" /> {{ 'Access via GUI'|t }}
      </label>

      <label>
        <input type="checkbox" v-model="epp_login" /> {{ 'Access via EPP'|t }}
      </label>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';
  import AutoCompleteRegistrar from '@/components/AutoCompleteRegistrar';

  export default {
    name: 'CreateForm',
    components: { AutoCompleteRegistrar },
    data() {
      return {
        registrar: "",
        username: "",
        password: "",
        admin: false,
        gui_login: true,
        epp_login: true,
      }
    },
    computed: {
      administrator() {
        return this.$store.getters['auth/isAdmin']
      }
    },
    methods: {
      submitForm() {
        let request = {
          registrar_email: this.registrar,
          name: this.username,
          password: this.password,
          admin: this.admin === true,
          gui_login: this.gui_login === true,
          epp_login: this.epp_login === true,
        };

        api.createUser(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "User %d has been created.",
              args: [data.id]
            }, {root: true});
            router.push({name: 'user.collection'});
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/user/CreateForm.vue